import MainView from "views/MainView";
import { queryStrToObject } from "request";
import { FormattedMessage } from "react-intl";
import { useEffect, useState } from "react";
import { useIntlContext, SupportedLocales } from "views/IntlContext";

export const ResetResult = () => {
  const { switchLanguage } = useIntlContext();
  const [isSuccess, setIsSuccess] = useState<boolean>(true);

  useEffect(() => {
    const queryData = queryStrToObject();
    if (queryData) {
      setIsSuccess(queryData?.code === "200");
      if (queryData?.lang) {
        switchLanguage?.(queryData.lang as SupportedLocales);
      }
    }
  }, []);

  return (
    <MainView backgroundClassName="bg-white dark:bg-black1b1f1e">
      <div className="pt-11 px-[22px] w-full">
        {isSuccess ? (
          <>
            <h2 className="font-bold text-2xl mb-4">
              <FormattedMessage id="reset.result.success.title" />
            </h2>
            <p>
              <FormattedMessage id="reset.result.success.tip" />
            </p>
          </>
        ) : (
          <>
            <h2 className="font-bold text-2xl mb-4">
              <FormattedMessage id="reset.result.expired.title" />
            </h2>
            <p>
              <FormattedMessage id="reset.result.expired.tip" />
            </p>
          </>
        )}
      </div>
    </MainView>
  );
};
